import React, { useState } from 'react';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';

export default function PasswordChanger() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = async () => {
    if (!currentPassword || !newPassword) {
      setMessage('❌ Please fill in both current and new password.');
      return;
    }

    if (newPassword.length < 6) {
      setMessage('❌ New password must be at least 6 characters long.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const user = auth.currentUser;
      if (!user || !user.email) {
        throw new Error('No authenticated user found');
      }

      // Re-authenticate user before password change
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      
      // Now update password
      await updatePassword(user, newPassword);
      
      setMessage('✅ Password updated successfully!');
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      console.error('Password change error:', err);
      if (err.code === 'auth/wrong-password') {
        setMessage('❌ Current password is incorrect.');
      } else if (err.code === 'auth/weak-password') {
        setMessage('❌ New password is too weak. Use at least 6 characters.');
      } else {
        setMessage(`❌ Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={inputGroup}>
        <label style={label}>Current Password</label>
        <input
          type="password"
          placeholder="Enter current password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          style={input}
          disabled={loading}
        />
      </div>
      
      <div style={inputGroup}>
        <label style={label}>New Password</label>
        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          style={input}
          disabled={loading}
        />
      </div>

      <button 
        onClick={handleChange} 
        style={button}
        disabled={loading}
      >
        {loading ? 'Updating...' : 'Update Password'}
      </button>
      
      {message && (
        <p style={{
          ...messageStyle,
          color: message.includes('✅') ? '#10b981' : '#ef4444'
        }}>
          {message}
        </p>
      )}
    </div>
  );
}

const container = {
  maxWidth: '400px',
};

const inputGroup = {
  marginBottom: '16px',
};

const label = {
  display: 'block',
  marginBottom: '6px',
  fontSize: '14px',
  fontWeight: 500,
  color: '#374151',
};

const input = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: '8px',
  border: '1px solid #d1d5db',
  fontSize: '14px',
  backgroundColor: '#f9fafb',
  outline: 'none',
  boxSizing: 'border-box',
};

const button = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#3b82f6',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 600,
  cursor: 'pointer',
  fontSize: '14px',
  marginTop: '8px',
};

const messageStyle = {
  marginTop: '12px',
  fontSize: '14px',
  fontWeight: 500,
};
